module.exports = __webpack_public_path__ + "media/images/game_icon/th/AB1045-68b9cf3a807384bc881b8b8a502e47d0.png";